import { render, staticRenderFns } from "./AgentWelcome.vue?vue&type=template&id=6d309cf6"
import script from "./AgentWelcome.vue?vue&type=script&lang=ts"
export * from "./AgentWelcome.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports